export default __webpack_public_path__ + "img/99d55aa991751b057e6e7ff3540ff9e7.png";